import { render } from "./AccidentLCheck.vue?vue&type=template&id=f812b768&scoped=true&ts=true"
import script from "./AccidentLCheck.vue?vue&type=script&lang=ts"
export * from "./AccidentLCheck.vue?vue&type=script&lang=ts"

import "./AccidentLCheck.vue?vue&type=style&index=0&id=f812b768&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f812b768"]])

export default __exports__